import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { BsPlus } from 'react-icons/bs';
import Avatar from 'components/Avatar';
import Text from 'components/styled/Text';
import { userSelector } from '../../../../store/selectors';
import { ROLES, colors } from '../../../../constants';
import EmployeeSelectModal from '../EmployeeSelectModal';

const EmployeeSelectContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const StyledOpenModalButton = styled.button`
  background-color: ${colors.green60};
  border-radius: 4px;
  width: 24px;
  height: 24px;
`;

const AvatarsContainer = styled.div`
  display: flex;
  > * {
    margin-left: -18px;
  }
`;

const EmployeeSelect = ({ team, ID }) => {
  const user = useSelector(userSelector);
  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleOpenModal = event => {
    event.stopPropagation();
    setIsOpenModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  return (
    <EmployeeSelectContainer>
      {user.role === ROLES.CLIENT && team[ROLES.EXPERT] && (
        <>
          <Avatar
            size="medium"
            image={team[ROLES.EXPERT].profile?.avatar?.url}
          />
          <Text variant="body-small">{`${
            team[ROLES.EXPERT].profile?.first_name
          } ${team[ROLES.EXPERT].profile?.last_name}`}</Text>
        </>
      )}
      {user.role !== ROLES.CLIENT && !!Object.values(team).length && (
        <AvatarsContainer>
          {Object.keys(team).map((role, index) => (
            <Avatar
              size="medium"
              key={index}
              title={`${team[role].profile?.first_name} ${team[role].profile?.last_name} (${role})`}
              image={team[role].profile?.avatar?.url}
            />
          ))}
        </AvatarsContainer>
      )}
      {(user.role === ROLES.MENTOR ||
        user.role === ROLES.MASTER ||
        user.role === ROLES.FOUNDER) && (
        <StyledOpenModalButton onClick={handleOpenModal}>
          <BsPlus fill={colors.green} />
        </StyledOpenModalButton>
      )}
      {isOpenModal && (
        <EmployeeSelectModal team={team} ID={ID} onClose={handleCloseModal} />
      )}
    </EmployeeSelectContainer>
  );
};

EmployeeSelect.propTypes = {
  team: PropTypes.object,
  ID: PropTypes.string.isRequired,
};

EmployeeSelect.defaultProps = {
  team: {},
};

export default EmployeeSelect;
